import { defineMessage } from 'services/localization';

export const messages = {
    warningTitle: defineMessage('warnings'),
    noWarnings: defineMessage('no_warnings_detected'),
    applicableWorkflowSettingsCopyWarning: defineMessage('only_applicable_workflo_ow_types_will_be_copied'),
    QBooksDifferentValues: defineMessage('if_values_are_different_ry_they_will_be_ignored'),
    QBooksDifferentClassesAndLocations: defineMessage('if_the_classes_and_loca__the_copy_will_not_work'),
    xeroDextRequesterWarning: defineMessage('dext_requester_wont_be_copied'),
    xeroNoDefaultSubmitterWarning: defineMessage('if_the_target_workflow__ull_from_xero_requester'),
    reviewerStepWarning: defineMessage('reviewer_step_wont_be_copied'),
    xeroCreateBillRequestersWarning: defineMessage('create_a_bill_in_approv_questers_wont_be_copied'),
    xeroMatrixRulesWarning: defineMessage('requester_rules_in_approval_matrix_wont_be_copied'),
    differentValuesInTargetOrgWarning: defineMessage('if_values_are_different_ms_they_will_be_ignored'),
    xeroCreatePORequestersWarning: defineMessage('create_a_po_in_approval_questers_wont_be_copied'),
    xeroNoCreateBillRequestersWarning: defineMessage('if_the_target_workflow__ot_have_such_requesters'),
    xeroNoCreatePORequestersWarning: defineMessage('if_the_target_workflow__ot_have_such_requesters_1'),
    trackingCategoryNameWarning: defineMessage('if_the_tracking_categor__the_copy_will_not_work'),
};
